// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const version = {
  hash: 'a74bce36d695a516a259fc7425c107037ef98d7e',
  hashShort: 'a74bce3',
  version: 'env/acceptance-2'
};
